/* eslint-disable @typescript-eslint/member-ordering */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as ApiCart from '../interfaces/api/cart';
import { BaseService } from './base.service';
import * as ApiPagination from '../interfaces/api/pagination';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CartService extends BaseService {
  private urlCart = `${this.apiUrl}/cart`;

  private cartCount = new BehaviorSubject<number>(0);
  cartCount$ = this.cartCount.asObservable();

  constructor(private http: HttpClient) {
    super();
  }

  setCartCount(count: number) {
    this.cartCount.next(count);
  }

  getCartCountValue() {
    return this.cartCount.getValue();
  }

  getCartCollection() {
    const url = new URL(`${this.urlCart}`);
    const queryParams: ApiPagination.RequestQuery = {
      page: 1,
      per_page: 100,
    };
    url.searchParams.set('page', queryParams.page?.toString());
    if (queryParams.per_page) {
      url.searchParams.set('perPage', queryParams.per_page?.toString());
    }
    return this.http.get<ApiCart.ResponseGetCart>(url.href);
  }

  getCartCount() {
    return this.http.get<any>(`${this.apiUrl}/cart_count`, {});
  }

  addToCart(productId: number, qty: number, warehouseId: number) {
    return this.http.post<ApiCart.ResponsePostAddToCart>(this.urlCart, {
      id_mh_product: productId,
      amount: qty,
      id_mh_warehouse: warehouseId,
    });
  }

  addToCartAddMinus(productId: number, qty: number, warehouseId: number) {
    return this.http.post<ApiCart.ResponsePostAddToCart>(`${this.urlCart}/add_minus`, {
      id_mh_product: productId,
      amount: qty,
      id_mh_warehouse: warehouseId,
    });
  }

  onChangeItemAmount(cartId: number, productId: number, amount: number, warehouseId: number) {
    return this.http.patch<ApiCart.ResponsePatchCart>(`${this.urlCart}/${cartId}?_method=patch`, {
      id_mh_product: productId,
      amount,
      id_mh_warehouse: warehouseId,
    });
  }

  onDeleteCartItem(cartId: number, no_loading: boolean = false) {
    const url = new URL(`${this.urlCart}/${cartId}`);
    if (no_loading) {
      url.searchParams.set('no_loading', no_loading?.toString());
    }

    return this.http.delete(url.href);
  }

  onBulkDeleteCartItem(cartIds: string) {
    return this.http.delete(`${this.urlCart}/bulk/${cartIds}`, {
      // params: {
      //   no_loading: true,
      // },
    });
  }

  getCartsByWarehouse(cartsParam: string) {
    return this.http.get<ApiCart.ResponseGetCartByWarehouse>(`${this.urlCart}/byWarehouse`, {
      params: {
        carts: cartsParam,
      },
    });
  }

  deleteCartByQueryCartId(cartsParam: string) {
    return this.http.delete<{ message: string }>(`${this.urlCart}/bulk/${cartsParam}`);
  }

  onChangeWarehouseCart(cartId: number, id_mh_warehouse: number) {
    return this.http.patch<ApiCart.ResponsePatchCart>(`${this.urlCart}/${cartId}`, {
      id_mh_warehouse,
    });
  }
}
